import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="max-w-lg w-full text-center animate-fade-up">
        <p className="font-sans uppercase tracking-[0.28em] text-xs text-terracotta mb-4" data-testid="payment-cancel">
          Kept quietly closed
        </p>
        <h1 className="font-serif text-4xl md:text-5xl text-bone-100 mb-6 leading-tight">
          No charge, no rush. <em className="text-bone-300 italic">Return when it feels right.</em>
        </h1>
        <p className="font-sans text-bone-300 mb-10 leading-relaxed">
          The workbook remains where you left it. Whenever you are ready, the door is still there.
        </p>
        <Link to="/dashboard">
          <Button
            className="rounded-none px-8 py-6 bg-transparent border border-obsidian-600 hover:border-terracotta hover:text-terracotta text-bone-200 font-sans uppercase tracking-wide text-xs transition-colors"
            data-testid="cancel-back-btn"
          >
            <ChevronLeft className="mr-3 h-4 w-4" /> Back to the workbook
          </Button>
        </Link>
      </div>
    </div>
  );
}
